import { getGameSize } from '../../../Config/Levels';
import { createBitmapText } from '../../../Utils/Utils';
import Core from '../../../Core/Core';

export class WinScreenScore extends PIXI.DisplayObject {
    constructor(score: number) {
        super();

        const size = getGameSize();
        const scoreText = createBitmapText(
            Core.local.getText('score'),
            new PIXI.Rectangle(
                size.gameWidth * 0.5,
                size.gameHeight * 0.45,
                size.gameWidth * 0.3,
                size.gameHeight * 0.1
            ),
            'riffic',
            26,
            0x006eba
        );
        scoreText.anchor = 0.5;

        const scoreNumText = createBitmapText(
            score.toString(10),
            new PIXI.Rectangle(
                size.gameWidth * 0.5,
                size.gameHeight * 0.52,
                size.gameWidth * 0.3,
                size.gameHeight * 0.05
            ),
            'score-font',
            26,
            0x006eba
        );
        scoreNumText.anchor = 0.5;
    }
}
